export default {
	title: '利益相关方',
	context_best: '有利',
	context_worse: '不利',
	zones: {
		positive: '有利',
		positive_line2: '区域',
		neutral: '中性',
		negative: '不利',
		negative_line2: '区域',
		point_of_view_line1: '观',
		point_of_view_line2: '点',
		point_of_view_line3: ''
	},
	alignment: {
		title_1: '利益相关方',
		title_2: '一致性'
	},
	tabs: {
		general: {
			title: '常规'
		},
		links: {
			title: '关联'
		},
		comments: {
			title: '历史'
		},
		filters: {
			title: '视图筛选'
		},
		export: {
			title: '导出',
			image: '将雷达导出为图片'
		},
		risks: {
			title: '风险'
		},
		bot: {
			title: '智能'
		},
		tags: {
			title: '标签',
			assigned: '已分配标签',
			unassigned: '未分配标签'
		},
		disabled: {
			title: '已停用'
		}
	},
	summary: {
		key_drivers: '关键驱动因素',
		scenario_score: '场景得分',
		max_value: '最高 {{value}}',
		legend: {
			current: '当前',
			scenario: '场景'
		}
	},
	all_tags: '标签筛选',
	links: '显示全部关联',
	no_tag: '无标签',

	all_icons: '图标筛选',
	no_icon: '无图标',

	all_stakes: '利害关系筛选',
	all_constraints: '指标筛选',
	all_risks: '风险筛选',
	all_opportunities: '突破口筛选',
	onboarding: {
		title: '审查利益相关方',
		description:
			'根据影响力和立场，对您主题产生重要影响的参与者已在雷达上定位。检查对齐情况，如果您的理解不同，请进行调整。'
	}
};
